/** Single source of truth for details that appear in several places. */

export const SITE = {
  name: "AlmanzaTech LLC",
  shortName: "AlmanzaTech",
  location: "Northern New Jersey",
  email: "bryant@almanzatech.com",
  phoneDisplay: "(201) 467-1007",
  phoneHref: "tel:+12014671007",
};
